import { AfterViewInit, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InspectionModel } from '@authority-labs/api-interfaces';
import { InspectionTypeEnum } from '@authority-labs/enums';
import { FilesService } from '@check-list/app/shared';
import { environment } from '@check-list/environments/environment';

@Component({
  templateUrl: './inspection-print-preview-dialog.component.html',
  styleUrls: ['./inspection-print-preview-dialog.component.scss']
})
export class InspectionPrintPreviewDialogComponent implements AfterViewInit {
  frame: Window;
  inProgress = true;
  downloading = false;
  inspectionTypes: InspectionTypeEnum[] = Object.values(InspectionTypeEnum);
  inspectionType: InspectionTypeEnum =
    InspectionTypeEnum.InspectionDesignAndInstallation;

  get isNew(): boolean {
    return this.inspectionId === 'new';
  }

  constructor(
    public dialogRef: MatDialogRef<InspectionModel>,
    private readonly filesService: FilesService,
    @Inject(MAT_DIALOG_DATA)
    public inspectionId: string = 'new'
  ) {}

  exportToPdf(): void {
    // this.frame?.print();
    this.downloading = true;

    this.filesService
      .downloadFile({
        url: this.getDownloadUrl(),
        openInNewTab: true
      })
      .finally(() => (this.downloading = false));
  }

  ngAfterViewInit(): void {
    const container = document.querySelector('#previewFrame');
    const iframe = document.createElement('iframe');

    iframe.style.width = '100%';
    iframe.style.height = this.isNew ? '52vh' : '63vh';
    iframe.style.border = 'none';
    iframe.onload = this.onFrameLoad.bind(this);
    iframe.src = this.getIframeSrc();

    container.appendChild(iframe);
  }

  onFrameLoad(): void {
    const container = document.querySelector('#previewFrame');
    this.frame = container.querySelector('iframe').contentWindow;
    this.inProgress = false;
  }

  onInspectionTypeChange(): void {
    this.inProgress = true;
    const container = document.querySelector('#previewFrame');
    const iframe = container.querySelector('iframe');
    iframe.src = this.getIframeSrc();
  }

  private getIframeSrc(): string {
    let src: string;

    if (this.isNew) {
      src = `/app/preview/new/?printPreview=true&inspectionType=${this.inspectionType}`;
    } else {
      src = `/app/preview/${this.inspectionId}?printPreview=true`;
    }

    return src;
  }

  private getDownloadUrl(): string {
    let url: string;

    if (this.isNew) {
      url = `${environment.API}/inspections/0/export?inspectionType=${this.inspectionType}`;
    } else {
      url = `${environment.API}/inspections/${this.inspectionId}/export`;
    }

    return url;
  }
}
